import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-edit-note-dialog',
  template: `
  <h1 mat-dialog-title>Edit Note</h1>

  <div mat-dialog-content class="content">
    <mat-form-field class="pl-3 pr-3">
      <textarea
        placeholder="Note description"
        matInput
        [(ngModel)]="data"
        cdkFocusInitial>
      ></textarea>
    </mat-form-field>
   </div>

  <mat-dialog-actions>
    <button mat-button (click)="onNoClick()">Cancel</button>
    <button mat-button [mat-dialog-close]="data" cdkFocusInitial>Update</button>
  </mat-dialog-actions>
  `,
  styleUrls: ['./dialog.scss']
})
export class EditNoteDialogComponent implements OnInit {

  //data: string;

  constructor(
    public dialogRef: MatDialogRef<EditNoteDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit(): void {
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
